import { render, staticRenderFns } from "./SectionBlock.vue?vue&type=template&id=63b382f3&scoped=true"
import script from "./SectionBlock.vue?vue&type=script&lang=js"
export * from "./SectionBlock.vue?vue&type=script&lang=js"
import style0 from "./SectionBlock.vue?vue&type=style&index=0&id=63b382f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b382f3",
  null
  
)

export default component.exports